import React from 'react';
import { Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection.jsx';
import ProductGrid from '../components/ProductGrid.jsx';
import CategoryDisplay from '../components/CategoryDisplay.jsx';
import FeatureHighlight from '../components/FeatureHighlight.jsx';
import SectionDivider from '../components/SectionDivider.jsx';
import Container from '../components/Container.jsx';
import { Button } from '../components/Button.jsx';

const categories = [
  { icon: '🥐', name: 'Petit-déjeuner', description: 'Viennoiseries, croissants, pains au chocolat et plus.' },
  { icon: '🥪', name: 'Déjeuner', description: 'Sandwichs, quiches, salades fraîches.' },
  { icon: '🍸', name: 'Cocktails', description: 'Petits fours, amuse-bouches, boissons artisanales.' },
  { icon: '🍰', name: 'Spécialités', description: 'Pâtisseries fines, spécialités maison.' },
];

const features = [
  { icon: '🌾', title: 'Farines locales', description: 'Nos pains sont réalisés à partir de farines françaises sélectionnées.' },
  { icon: '🔥', title: 'Four traditionnel', description: 'Cuisson sur pierre pour une croûte dorée et un goût authentique.' },
  { icon: '👨‍🍳', title: 'Savoir-faire artisanal', description: 'Recettes transmises de génération en génération.' },
  { icon: '💛', title: 'Accueil chaleureux', description: 'Une équipe passionnée à votre service chaque jour.' },
];

export function Homepage() {
  return (
    <>
      <HeroSection
        headline="La passion du pain, l’excellence Antic."
        subheadline="Découvrez l’art de la boulangerie française, entre tradition et innovation."
        actions={[
          <Link key="cta1" to="/products">
            <Button variant="primary" size="lg">Découvrir nos produits</Button>
          </Link>,
          <Link key="cta2" to="/about">
            <Button variant="secondary" size="lg">En savoir plus</Button>
          </Link>
        ]}
        background="/images/hero-bakery.jpg"
      />
      <SectionDivider motif />
      <Container id="categories" className="py-12">
        <h2 className="text-3xl font-heading font-bold text-center mb-8 text-primary">Nos catégories phares</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {categories.map((cat) => (
            <CategoryDisplay key={cat.name} {...cat} />
          ))}
        </div>
      </Container>
      <SectionDivider />
      <Container className="py-12">
        <h2 className="text-3xl font-heading font-bold text-center mb-8 text-primary">L’esprit Antic</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {features.map((f) => (
            <FeatureHighlight key={f.title} {...f} />
          ))}
        </div>
      </Container>
    </>
  );
}

export default Homepage;
